import React from 'react';
import styles from './assets/login-screen.module.scss';
import LoginAuthCodeForm from './components/LoginAuthCodeForm';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface StateProps {
    inProgress: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DispatchProps {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class LoginAuthCodeScreen extends React.Component<Props> {
    render() {
        if (this.props.inProgress) {
            return <Loader />;
        }
        return (
            <div className={classNames(styles.loginWrapper)}>
                <div className={classNames('container')}>
                    <div className={classNames('row')}>
                        <div className={classNames('col-lg-3')}></div>
                        <div className={classNames('col-lg-6')}>
                            <div className={classNames(styles.authContent)}>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        marginTop: '30px',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <div
                                        className={classNames(
                                            styles.infoIcon,
                                            '  d-flex justify-content-center align-items-center',
                                        )}
                                    >
                                        <FontAwesomeIcon className={classNames(styles.icon)} icon={faEnvelope} />
                                    </div>
                                    <div className={classNames(styles.infoIconTitle)}>
                                        {' '}
                                        {window?.location?.origin === 'https://staging.providerpoint.net'
                                            ? 'Training System'
                                            : 'Login the system'}
                                    </div>
                                </div>
                                <LoginAuthCodeForm isCode={true} />
                            </div>
                        </div>
                        <div className={classNames('col-lg-3')}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginAuthCodeScreen;
